"use strict";

angular.module("core").component("pagination", {
    templateUrl: require("./pagination.component.html"),
    controller: function() {
        this.update = function() {
            this.onChange();
        };
    },
    bindings: {
        data: "=",
        onChange: "&"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/pagination/pagination.component.js
// module id = 545
// module chunks = 0